import { EnrollmentGroup } from './enrollment';

export interface GTeacher {
  id: number;
  enrollmentGroups: EnrollmentGroup[];
  name: string;
  avatarUrl: string;
  wechatQrCode: string;
}

export enum UserSource {
  NORMAL,
  SLM,
}

export const USER_SOURCE_TO_NAME = {
  [UserSource.NORMAL]: '正常',
  [UserSource.SLM]: '分销',
};



// WEBPACK FOOTER //
// ./src/types/teacher.ts